import { render, staticRenderFns } from "./storageTemp.vue?vue&type=template&id=5efbbdf5"
import script from "./storageTemp.vue?vue&type=script&lang=js"
export * from "./storageTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports